
import React from 'react';
import { Card } from '@/components/ui/card';
import { CycleImportRow } from '@/utils/cycle-tracking/import';

interface DataPreviewProps {
  parsedData: CycleImportRow[];
}

const DataPreview: React.FC<DataPreviewProps> = ({ parsedData }) => {
  if (parsedData.length === 0) {
    return null;
  }

  return (
    <Card className="p-6">
      <h2 className="text-lg font-medium mb-4">Data Preview</h2>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-muted">
              <th className="px-4 py-2 text-left">Start Date</th>
              <th className="px-4 py-2 text-left">End Date</th>
              <th className="px-4 py-2 text-left">Symptoms</th>
              <th className="px-4 py-2 text-left">Mood</th>
              <th className="px-4 py-2 text-left">Medications</th>
              <th className="px-4 py-2 text-left">Contraception</th>
            </tr>
          </thead>
          <tbody>
            {parsedData.map((row, index) => (
              <tr key={index} className="border-t">
                <td className="px-4 py-2">{row.cycleStartDate.toLocaleDateString()}</td>
                <td className="px-4 py-2">{row.cycleEndDate.toLocaleDateString()}</td>
                <td className="px-4 py-2">{row.symptoms?.join(', ') || '-'}</td>
                <td className="px-4 py-2">{row.mood || '-'}</td>
                <td className="px-4 py-2">{row.medications?.join(', ') || '-'}</td>
                <td className="px-4 py-2">{row.contraceptiveUse || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
};

export default DataPreview;
